exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.social-media-wrapper[data-v-109014c8]{text-align:center;padding:24px\n}\n.social-media-wrapper h2[data-v-109014c8]{display:inline-block;margin:24px 0;cursor:pointer;font-size:2.5em;margin-top:35px\n}\n@media(max-width: 769px){\n.social-media-wrapper h2[data-v-109014c8]{font-size:1.9em\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-109014c8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/social_media/SocialMedia.vue
// module id = BFS4
// module chunks = 1